import React from 'react';
import {AI_MEMORY_MAX} from '../constants';
import {StepProps} from './types';

/**
 * Шаг «Что важно знать стилисту» (слот 11): свободный контекст, который уезжает в
 * `UserSettings.aiMemory` и попадает в системный промпт AI. Ответ — строка, а не объект:
 * так его понимает маппинг `complete()` из CTHS-215.
 */
const StepAiMemory: React.FC<StepProps> = ({value, onChange}) => {
    const text = typeof value === 'string' ? value : '';

    return (
        <div className="space-y-2" data-testid="onboarding-step-ai-memory">
            <label className="flex flex-col gap-1">
                <span className="text-sm text-gray-700 dark:text-gray-300">
                    Контекст для стилиста
                </span>
                <textarea
                    value={text}
                    maxLength={AI_MEMORY_MAX}
                    rows={5}
                    onChange={e => onChange(e.target.value)}
                    className="input-field min-h-[120px] resize-y"
                    placeholder="Не ношу яркое, на работе дресс-код smart casual, зимой мёрзну, люблю тёмно-синий"
                    data-testid="onboarding-ai-memory-text"
                />
            </label>
            <p className="text-xs text-gray-500 dark:text-gray-400 text-right" data-testid="onboarding-ai-memory-counter">
                {text.length} / {AI_MEMORY_MAX}
            </p>
        </div>
    );
};

export default StepAiMemory;
